import {browserName} from 'react-device-detect';

const getDevice = (): string => `${browserName}`;

export default getDevice;